import styled from 'styled-components'

export const Container = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 400px;
  background: white;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  transform: translateX(${(props) => (props.$isOpen ? '0' : '100%')});
  transition: transform 0.3s ease-in-out;
  z-index: 9999;
  display: flex;
  flex-direction: column;

  @media print {
    display: none !important;
    visibility: hidden !important;
  }
`

export const ToggleButton = styled.button<{ $isOpen: boolean }>`
  position: fixed;
  top: 50%;
  right: ${(props) => (props.$isOpen ? '400px' : '0')};
  transform: translateY(-50%);
  background: #ff6b6b;
  color: white;
  border: none;
  padding: 12px 8px;
  cursor: pointer;
  z-index: 10000;
  transition: right 0.3s ease-in-out;
  border-radius: ${(props) => (props.$isOpen ? '4px 0 0 4px' : '4px 0 0 4px')};
  font-size: 14px;
  font-weight: 600;
  writing-mode: vertical-lr;
  text-orientation: mixed;

  &:hover {
    background: #ff5252;
  }
  @media (max-width: 768px) {
    z-index: 0;
  }

  @media print {
    display: none !important;
    visibility: hidden !important;
  }
`

export const Header = styled.div`
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
`

export const Title = styled.h3`
  margin: 0 0 10px 0;
  font-size: 18px;
  color: #212529;
`

export const Stats = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 10px;
`

export const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const StatLabel = styled.span`
  font-size: 12px;
  color: #6c757d;
`

export const StatValue = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #212529;
`

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
`

export const TranslationItem = styled.div`
  padding: 12px;
  background: #f8f9fa;
  border-radius: 4px;
  margin-bottom: 8px;
  border: 1px solid #e9ecef;
`

export const TranslationKey = styled.div`
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: #495057;
  margin-bottom: 4px;
  word-break: break-all;
`

export const TranslationMeta = styled.div`
  display: flex;
  gap: 12px;
  font-size: 11px;
  color: #6c757d;
`

export const Badge = styled.span<{ $type?: 'namespace' | 'language' }>`
  padding: 2px 6px;
  border-radius: 3px;
  background: ${(props) => {
    switch (props.$type) {
      case 'namespace':
        return '#e3f2fd'
      case 'language':
        return '#f3e5f5'
      default:
        return '#e9ecef'
    }
  }};
  color: ${(props) => {
    switch (props.$type) {
      case 'namespace':
        return '#1976d2'
      case 'language':
        return '#7b1fa2'
      default:
        return '#495057'
    }
  }};
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #6c757d;
`

export const AutoTranslateInfo = styled.div`
  padding: 12px;
  background: #e7f5ff;
  border: 1px solid #a5d8ff;
  border-radius: 4px;
  margin: 16px 0;
  font-size: 13px;
  color: #1971c2;
`

export const ClearButton = styled.button`
  padding: 8px 16px;
  background: #e9ecef;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  color: #495057;
  transition: background 0.2s;

  &:hover {
    background: #dee2e6;
  }
`
